// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import amendmentChangeEntity from './entities/amendment-change.json';
import amendmentChangeMenu from '../pages/amendment-change/menu.json';
import amendmentChangeFullForm from '../pages/amendment-change/forms/full.json';
import amendmentChangeContextForm from '../pages/amendment-change/forms/context.json';
import amendmentChangeMiniForm from '../pages/amendment-change/forms/mini.json';
import amendmentChangeLookupForm from '../pages/amendment-change/forms/lookup.json';
import amendmentChangeTableView from '../pages/amendment-change/views/table.json';
import amendmentChangeCardsView from '../pages/amendment-change/views/cards.json';
import amendmentChangeDashboardView from '../pages/amendment-change/views/dashboard.json';

/** Тип запису «Зміна до статті» зі сторінками пакета: меню, форми та подання з pages/amendment-change/. */
export const amendmentChangeDefinition: IRecordTypeDefinition = {
  ...amendmentChangeEntity,
  views: assembleViewSet({
      table: amendmentChangeTableView,
      cards: amendmentChangeCardsView,
      dashboard: amendmentChangeDashboardView,
  }),
  form: amendmentChangeFullForm,
  forms: { full: amendmentChangeFullForm, context: amendmentChangeContextForm, mini: amendmentChangeMiniForm, lookup: amendmentChangeLookupForm },
  menu: amendmentChangeMenu,
} as IRecordTypeDefinition;
